/*
 * File: /src/router/routes/knowledgeTypes.js
 * Author: AdBase, Inc.
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */

const KnowledgeTypeList = () =>
  import(
    /* webpackChunkName: "KnowledgeTypes" */ 'src/components/Dashboard/Views/KnowledgeTypes/KnowledgeTypeList.vue'
  );
const KnowledgeTypeEdit = () =>
  import(
    /* webpackChunkName: "KnowledgeTypes" */ 'src/components/Dashboard/Views/KnowledgeTypes/KnowledgeTypeEdit.vue'
  );

export const knowledgeTypeRoutes = [
  {
    path: 'knowledge-types/list',
    name: 'Knowledge Type List',
    component: KnowledgeTypeList,
  },
  {
    path: 'knowledge-types/add',
    name: 'Knowledge Type Add',
    component: KnowledgeTypeEdit,
    props: () => ({
      id: undefined,
    }),
  },
  {
    path: 'knowledge-types/edit/:id',
    name: 'Knowledge Type Edit',
    component: KnowledgeTypeEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
];
